import { pmsApi } from 'features/purchase/pms/pmsApi'
import { Subscription, SubscriptionStatusEnum } from 'types/subscription'

import { getStore } from '@/store'
import { TTranslationFunction } from '@/types'
import { getValidErrorMessage } from '@/utils/apiUtils'

import { bannerDialogStateAtom } from '../Banners/bannerStates'
import { getCurrentSubscriptionFromPms } from './getCurrentSubscription'
import {
	reactivateIsInProgressAtom,
	subscriptionAtom,
} from './subscriptionState'

export const reactivateSubscription = async (
	subscription: Subscription,
	t: TTranslationFunction,
) => {
	const store = getStore()
	const reactivateIsInProgress = store.get(reactivateIsInProgressAtom)

	if (
		!subscription.id ||
		subscription.status === SubscriptionStatusEnum.ACTIVE ||
		reactivateIsInProgress
	) {
		return
	}

	try {
		store.set(reactivateIsInProgressAtom, true)

		// MYQRCODE-10803 AC#1: reactivate goes straight to the PMS client API —
		// the PMS internal API has no reactivate endpoint, so qr-api can't relay it.
		await pmsApi.reactivateUserSubscription()
		// 'en': this fn is called from 6 different bannerConfig.ts files with
		// no locale in scope, and nothing downstream of subscriptionAtom
		// renders this subscription's locale-formatted price strings.
		const currentSubscriptionResponse =
			await getCurrentSubscriptionFromPms('en')
		store.set(subscriptionAtom, currentSubscriptionResponse)

		store.set(bannerDialogStateAtom, {
			title: t('dashboard__resubscribe_success__popup_title'),
			description: t('dashboard__resubscribe_success__popup_description'),
			actionLabel: t('dashboard__resubscribe__popup_button'),
		})
	} catch (error) {
		console.error(error)
		store.set(bannerDialogStateAtom, {
			title: t('dashboard__subscription_failed__popup_title'),
			description: getValidErrorMessage(error, t),
			actionLabel: t('dashboard__resubscribe__popup_button'),
		})
	} finally {
		store.set(reactivateIsInProgressAtom, false)
	}
}
